import React, { Fragment, useEffect, useState } from 'react';
import { Row, Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
    API_Ingetration,
    gAPI_Internal_Property_By_Id,
    gAPI_Property_List_By_Group,
} from '../../../../../../constants/APIs';

import OracleOperaIntegration from '../../../integration/components/OracleOpera/OracleOperaIntegration';
import OracleOperaIntegrationThumb from './Components/OracleOperaIntegrationThumb';
import RMSIntegration from '../../../integration/components/RMSIntegration';
import RMSIntegrationThumb from './Components/RMSIntegrationThumb';
import Oracle_logo from '../../../../../../assets/Oracle_logo.png';
import RMSLogo from '../../../../../../assets/rms.ico';

const Applications = ({ propertyId, userName }) => {
    const [allProperties, setAllProperties] = useState([]);
    const [oracleOperaIntegration, setOracleOperaIntegration] = useState([]);
    const [rmsBookingEngineData, setRMSBookingEngineData] = useState([]);
    const [isAddOracleOpera, setIsAddOracleOpera] = useState(false);
    const [isAddRms, setIsAddRms] = useState(false);
    const [isGuestMessaging, setIsGuestMessaging] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const LoadIntegrations = () => {
        setIsLoading(true);

        const body = {
            channels: ['OracleOpera', 'RMSBookingEngine'],
        };

        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body,
        })
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];

                const oracle = data.filter(
                    (k) =>
                        String(k.channel).toLowerCase() === 'oracleopera' &&
                        k.properties?.includes(propertyId)
                );
                const Rms = data.filter(
                    (k) =>
                        String(k.channel).toLowerCase() === 'rmsbookingengine' &&
                        k.properties?.includes(propertyId)
                );

                setOracleOperaIntegration(oracle);
                setRMSBookingEngineData(Rms)
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.error('Error loading Oracle Opera integrations:', err);
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (!propertyId) return;

        AxiosAPI({
            method: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                const data = res.data || {};
                setIsGuestMessaging(Boolean(data.isGuestMessaging));
            })
            // eslint-disable-next-line no-console
            .catch((err) => console.error('Error fetching property capabilities:', err));
    }, [propertyId]);

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
            .then((res) => setAllProperties(res.data || []))
            // eslint-disable-next-line no-console
            .catch((err) => console.error('Error loading properties list:', err));
    }, []);


    useEffect(() => {
        LoadIntegrations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    const hasAnyIntegration = oracleOperaIntegration.length > 0 || rmsBookingEngineData.length > 0

    const renderConnectCard = () => (
        <Row className="m-2 my-3">
            <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
                    <CardBody className="mt-0">
                        <div className="connect-title">
                            <div className="integrationChannel mt-3">
                                <img src={Oracle_logo} alt="Oracle Opera" style={{ width: '3rem' }} />
                            </div>
                            {!isGuestMessaging ? (
                                <Button size="xs" color="outline-grey">
                                    <span>Not Available</span>
                                </Button>
                            ) : (
                                <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddOracleOpera(true)}
                                >
                                    <IntlMessages id="dashboards.connect" />
                                </Button>
                            )}
                        </div>

                        <Row>
                            <Colxx xxs="12" className="mb-5" style={{ marginTop: '2rem' }}>
                                <div className="text-left">
                                    <h2>Oracle Opera Cloud</h2>
                                    <span>
                                        Provide 24/7 pre-checkin engagement. Message
                                        your guests before their arrival, with
                                        information, guidance, and personalised
                                        upsell options.
                                    </span>
                                </div>
                            </Colxx>
                        </Row>
                    </CardBody>
                </Card>
            </Colxx>
            <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                >
                    <CardBody className="mt-0">
                        <div className="connect-title">
                            <div className="integrationChannel mt-4 ml-2">
                                <img
                                    src={RMSLogo}
                                    style={{ width: '2rem' }}
                                ></img>
                            </div>
                            {!isGuestMessaging ? (
                                <Button size="xs" color="outline-grey">
                                    <span>Not Available</span>
                                </Button>
                            ) : (
                                <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddRms(!isAddRms)}
                                >
                                    <IntlMessages id="dashboards.connect" />
                                </Button>
                            )}
                        </div>
                        <Row>
                            <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                            >
                                <div className="text-left">
                                    <h2>RMS Booking Engine</h2>
                                    <span>
                                        Show the AI Chatbot Web Widget inside the
                                        RMS Booking Engine.
                                    </span>
                                </div>
                            </Colxx>
                        </Row>
                    </CardBody>
                </Card>
            </Colxx>
        </Row>
    );

    const renderConnectedSection = () => (
        <Fragment>
            <Separator className="mb-3" />
            <Row className="m-2 my-3">
                <Colxx xxs="12" className="mb-2">
                    <h5>
                        <b>
                            Connected Applications
                        </b>
                    </h5>
                </Colxx>
            </Row>

            <Row className="m-2">
                {isLoading ? (
                    <div className="text-center loading" />
                ) : (
                    <Fragment>
                        {oracleOperaIntegration.map((integration, index) => (
                            <Fragment key={`oracle-${integration.id || index}`}>
                                <OracleOperaIntegrationThumb
                                    integration={integration}
                                    allProperties={allProperties}
                                    LoadIntegrations={LoadIntegrations}
                                />
                            </Fragment>
                        ))}
                        {rmsBookingEngineData.map((integration, index) => (
                            <Fragment key={`rms-${integration.id || index}`}>
                                <RMSIntegrationThumb
                                    integration={integration}
                                    allProperties={allProperties}
                                    LoadIntegrations={LoadIntegrations}
                                />
                            </Fragment>
                        ))}
                    </Fragment>
                )}
            </Row>
        </Fragment>
    );
    return (
        <Fragment>
            {/* Top "Connect" card – Oracle Opera */}
            {renderConnectCard()}

            {/* Connected Oracle Opera integrations */}
            {hasAnyIntegration && renderConnectedSection()}

            {/* Modal for creating new Oracle Opera integration */}
            {isAddOracleOpera && (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx md="4" sm="4" lg="4" xxs="12" />
                            <Colxx md="4" sm="4" lg="4" xxs="12">
                                <OracleOperaIntegration
                                    visible={isAddOracleOpera}
                                    toggle={() => {
                                        setIsAddOracleOpera(false);
                                        LoadIntegrations();
                                    }}
                                />
                            </Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12" />
                        </Row>
                    </Colxx>
                </Row>
            )}
            {isAddRms ? (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12">
                                <RMSIntegration
                                    visible={isAddRms}
                                    toggle={() => {
                                        setIsAddRms(!isAddRms);
                                        LoadIntegrations();
                                    }}
                                />
                            </Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                        </Row>
                    </Colxx>
                </Row>
            ) : null}
        </Fragment>
    );
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, userName } = settings;
    return {
        propertyId,
        userName,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Applications));